import {getAuthToken, getCampaignId} from '~/utils/url';
// Constants
import {
  DEFAULT_PRODUCT_PRICE,
  SUGGESTED_PRICE_MATCHERS
} from '~/constants/FundraisingConstants';
// Selectors
import {getStyle} from '~/selectors/CatalogSelectors';
import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {getAnchorColor} from '~/selectors/ProductSelectors';

export const getFundraisingState = state =>
  state.fundraising.present || state.fundraising;

export const goalQuantity = state =>
  getFundraisingState(state).get('goalQuantity');
export const salePricesJS = state =>
  getFundraisingState(state).get('salePrices').toJS();
export const printMinimumsJS = state =>
  getFundraisingState(state).get('printMinimums').toJS();
export const skipOverview = state =>
  isFundraisingMode(state) || getFundraisingState(state).get('skipOverview');
export const profitsJS = state =>
  getFundraisingState(state).get('profits').toJS();
export const minProfit = state => getFundraisingState(state).get('minProfit');
export const maxProfit = state => getFundraisingState(state).get('maxProfit');
export const isFetching = state => getFundraisingState(state).get('fetching');

export const getSalePrice = state => {
  const anchorColor = getAnchorColor(state);
  const salePrices = salePricesJS(state);
  return parseFloat(salePrices[anchorColor.id]);
};

export const getPrintMinimum = state => {
  const printMinimums = Object.values(printMinimumsJS(state));
  const printMinErrorMessage = printMinimums.filter(printMin => {
    if (printMin.errorMessage) return printMin.errorMessage;
  });
  if (printMinErrorMessage[0]) {
    return printMinErrorMessage[0];
  } else {
    const printMinimumData = printMinimums.reduce(
      (max, printMinimum) =>
        printMinimum.printMinimumQuantity > max.printMinimumQuantity
          ? printMinimum
          : max,
      printMinimums[0]
    );
    return printMinimumData;
  }
};

export const getComplementaryProducts = state => {
  const anchorColor = getAnchorColor(state);
  const salePrices = salePricesJS(state);
  const complementaryProducts = [];
  Object.keys(salePrices).forEach(productKey => {
    if (productKey !== anchorColor.id) {
      complementaryProducts.push({
        productId: parseInt(productKey, 10),
        salesPrice: parseFloat(salePrices[productKey])
      });
    }
  });
  return complementaryProducts;
};

export const getComplementaryProductsAsString = state => {
  return JSON.stringify(getComplementaryProducts(state));
};

export const getComplementaryProductIdsAsString = state => {
  return getComplementaryProducts(state)
    ?.map(product => product.productId)
    ?.join(';');
};

export const getSuggestedPriceForStyle = (state, styleId) => {
  const style = getStyle(state, {styleId: styleId});
  const styleName = style.name;
  let suggestedPrice = DEFAULT_PRODUCT_PRICE;
  for (const [price, matcher] of Object.entries(
    SUGGESTED_PRICE_MATCHERS
  ).reverse()) {
    const regEx = new RegExp(matcher, 'i');
    if (styleName.match(regEx)) {
      suggestedPrice = price;
      break;
    }
  }
  return parseInt(suggestedPrice, 10);
};

export const getCampaignIdFromUrl = () => getCampaignId();
export const getAuthTokenFromUrl = () => getAuthToken();
